// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#vid-file-select-row,#vid-url-select-row{display:flex}#vid-url-select-row{margin-top:8px}
`, "",{"version":3,"sources":["webpack://./src/components/editors/CommonComponents/VideoUploadComponent.scss"],"names":[],"mappings":"AAAA,yCAEE,YAAa,CACd,oBAGC,cAAe","sourcesContent":["#vid-file-select-row,\n#vid-url-select-row {\n  display: flex;\n}\n\n#vid-url-select-row {\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
